module.exports = __webpack_public_path__ + "img/logo.7370d9f8.svg";